/* eslint-disable max-len */
const React = require('react');
const PointEs = require('./pointES');
const PointPT = require('./pointPT');
const PointREPT = require('./pointREPT');
const PointREES = require('./pointREES');
const PointMLA = require('./pointMLA');

const Point = {
  es: PointEs,
  pt: PointPT,
  en: PointEs,
  're-pt': PointREPT,
  're-es': PointREES,
  're-en': PointREES,
  mla: PointMLA,
};

module.exports = Point;
